/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ViewDemandeDialog = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
      <Dialog open={viewDialogOpen} onOpenChange={setViewDialogOpen}>
        <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto p-0 gap-0" data-testid="demande-view-dialog">
          {viewingDemande && (
            <>
              {/* HERO — fond gradient institutionnel */}
              <div className="relative overflow-hidden bg-gradient-to-br from-[#0a1e3f] via-[#0B3C5D] to-[#0a1e3f] text-white p-6">
                <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#fbbf24] to-transparent" />
                <div className="absolute -right-12 -top-12 w-48 h-48 rounded-full bg-[#fbbf24]/10 blur-3xl pointer-events-none" />
                <div className="relative flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] uppercase tracking-[0.3em] text-[#fbbf24]/90 font-medium mb-1.5">
                      O&apos;SCOP · Demande Publique
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold leading-tight tracking-tight mb-2" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>
                      {viewingDemande.title || viewingDemande.titre || 'Demande sans titre'}
                    </h2>
                    <div className="flex flex-wrap items-center gap-2">
                      <Badge className="bg-slate-900 text-white/80 text-amber-300 border border-amber-400/40 font-mono uppercase text-[10px] tracking-wider shadow-sm font-semibold">
                        <Tag className="h-3 w-3 mr-1 text-amber-300" />
                        {viewingDemande.type_demande || 'standard'}
                      </Badge>
                      <Badge className={
                        viewingDemande.statut === 'disponible' ? 'bg-emerald-500 text-white border-0' :
                        viewingDemande.statut === 'achetee' ? 'bg-blue-500 text-white border-0' :
                        viewingDemande.statut === 'suspendue' ? 'bg-orange-500 text-white border-0' :
                        viewingDemande.statut === 'en_cours' ? 'bg-purple-500 text-white border-0' :
                        'bg-slate-500 text-white border-0'
                      }>
                        {viewingDemande.statut || 'nouvelle'}
                      </Badge>
                      {viewingDemande.oscop_id && (
                        <Badge variant="outline" className="border-[#fbbf24]/40 text-[#fbbf24] font-mono text-[10px] tracking-wider bg-[#fbbf24]/5">
                          {viewingDemande.oscop_id}
                        </Badge>
                      )}
                      <Badge variant="outline" className="border-white/20 text-white/80 text-[10px]">
                        ID : {viewingDemande.id?.substring(0, 8) || '—'}
                      </Badge>
                    </div>
                  </div>
                  {/* Prix mis en valeur */}
                  <div className="text-right shrink-0 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-3 min-w-[120px]">
                    <div className="text-3xl font-bold text-[#fbbf24]">{viewingDemande.prix || 15}€</div>
                    <div className="text-xs text-white/70">ou {viewingDemande.prix_credits || 5} crédits</div>
                  </div>
                </div>
              </div>

              {/* Body */}
              <div className="p-6 space-y-5 bg-white">
                {/* Section : Description */}
                {viewingDemande.description && (
                  <section>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-emerald-700 border-l-4 border-emerald-500 pl-2 mb-2">
                      Description
                    </h3>
                    <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap bg-slate-50 rounded-lg p-3 border border-slate-200">
                      {viewingDemande.description}
                    </p>
                  </section>
                )}

                {/* Section : Localisation */}
                <section>
                  <h3 className="text-xs font-bold uppercase tracking-wider text-sky-700 border-l-4 border-sky-500 pl-2 mb-2">
                    Localisation
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    <div className="bg-sky-50/60 rounded-lg p-3 border border-sky-200">
                      <div className="text-[10px] uppercase tracking-wider text-sky-700 font-semibold flex items-center gap-1">
                        <MapPin className="h-3 w-3" /> Territoire
                      </div>
                      <div className="text-sm font-bold text-slate-800 mt-1">
                        {territoiresList.find(t => t.value === viewingDemande.territoire)?.label || viewingDemande.territoire || 'Non spécifié'}
                      </div>
                    </div>
                    <div className="bg-sky-50/60 rounded-lg p-3 border border-sky-200">
                      <div className="text-[10px] uppercase tracking-wider text-sky-700 font-semibold">Ville</div>
                      <div className="text-sm font-bold text-slate-800 mt-1">{viewingDemande.ville || '—'}</div>
                    </div>
                    <div className="bg-sky-50/60 rounded-lg p-3 border border-sky-200">
                      <div className="text-[10px] uppercase tracking-wider text-sky-700 font-semibold">Code postal</div>
                      <div className="text-sm font-bold text-slate-800 mt-1 font-mono">{viewingDemande.code_postal || '—'}</div>
                    </div>
                  </div>
                  {viewingDemande.adresse && (
                    <p className="text-xs text-slate-600 mt-2 pl-1">
                      <span className="font-semibold">Adresse :</span> {viewingDemande.adresse}
                    </p>
                  )}
                </section>

                {/* Section : Entreprise & Contact */}
                <section>
                  <h3 className="text-xs font-bold uppercase tracking-wider text-purple-700 border-l-4 border-purple-500 pl-2 mb-2">
                    Entreprise &amp; Contact
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="bg-purple-50/60 rounded-lg p-3 border border-purple-200 space-y-1">
                      <div className="text-[10px] uppercase tracking-wider text-purple-700 font-semibold flex items-center gap-1">
                        <Building2 className="h-3 w-3" /> Type d&apos;entreprise
                      </div>
                      <div className="text-sm font-bold text-slate-800">
                        {typesEntrepriseList.find(t => t.value === viewingDemande.type_entreprise)?.label || viewingDemande.type_entreprise || 'Non spécifié'}
                      </div>
                      {viewingDemande.entreprise && (
                        <div className="text-xs text-slate-600 mt-1">{viewingDemande.entreprise}</div>
                      )}
                      {viewingDemande.secteur && (
                        <div className="text-xs text-slate-500 mt-0.5">Secteur : {viewingDemande.secteur}</div>
                      )}
                    </div>
                    <div className="bg-purple-50/60 rounded-lg p-3 border border-purple-200 space-y-1">
                      <div className="text-[10px] uppercase tracking-wider text-purple-700 font-semibold">Contact</div>
                      {viewingDemande.contact && (<div className="text-sm font-bold text-slate-800">{viewingDemande.contact}</div>)}
                      {viewingDemande.email && (
                        <a href={`mailto:${viewingDemande.email}`} className="text-xs text-blue-600 hover:underline block break-all">
                          ✉ {viewingDemande.email}
                        </a>
                      )}
                      {viewingDemande.telephone && (
                        <a href={`tel:${viewingDemande.telephone}`} className="text-xs text-blue-600 hover:underline block">
                          ☎ {viewingDemande.telephone}
                        </a>
                      )}
                      {!viewingDemande.email && !viewingDemande.telephone && !viewingDemande.contact && (
                        <div className="text-xs text-slate-400 italic">Aucun contact renseigne</div>
                      )}
                    </div>
                  </div>
                </section>

                {/* Section : Tarification & Dates */}
                <section>
                  <h3 className="text-xs font-bold uppercase tracking-wider text-amber-700 border-l-4 border-amber-500 pl-2 mb-2">
                    Tarification &amp; Echeance
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div className="bg-gradient-to-br from-emerald-50 to-emerald-100/40 rounded-lg p-3 border border-emerald-200">
                      <div className="text-[10px] uppercase tracking-wider text-emerald-700 font-semibold flex items-center gap-1">
                        <Euro className="h-3 w-3" /> Prix CB
                      </div>
                      <div className="text-xl font-bold text-emerald-900 mt-1">{viewingDemande.prix || 15}€</div>
                    </div>
                    <div className="bg-gradient-to-br from-purple-50 to-purple-100/40 rounded-lg p-3 border border-purple-200">
                      <div className="text-[10px] uppercase tracking-wider text-purple-700 font-semibold flex items-center gap-1">
                        <Coins className="h-3 w-3" /> Credits
                      </div>
                      <div className="text-xl font-bold text-purple-900 mt-1">{viewingDemande.prix_credits || 5}</div>
                    </div>
                    {viewingDemande.montant_estime && (
                      <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
                        <div className="text-[10px] uppercase tracking-wider text-blue-700 font-semibold">Montant estimé</div>
                        <div className="text-sm font-bold text-blue-900 mt-1">{viewingDemande.montant_estime}€</div>
                      </div>
                    )}
                    <div className="bg-slate-50 rounded-lg p-3 border border-slate-200">
                      <div className="text-[10px] uppercase tracking-wider text-slate-600 font-semibold flex items-center gap-1">
                        <Clock className="h-3 w-3" /> Créée
                      </div>
                      <div className="text-sm font-bold text-slate-800 mt-1">
                        {viewingDemande.created_at ? new Date(viewingDemande.created_at).toLocaleDateString('fr-FR') : '—'}
                      </div>
                    </div>
                  </div>
                  {(viewingDemande.deadline_response || viewingDemande.deadline_decision) && (
                    <div className="grid grid-cols-2 gap-3 mt-3">
                      {viewingDemande.deadline_response && (
                        <div className="bg-rose-50 rounded-lg p-2.5 border border-rose-200">
                          <div className="text-[10px] uppercase tracking-wider text-rose-700 font-semibold">Deadline reponse</div>
                          <div className="text-sm font-semibold text-rose-900">{new Date(viewingDemande.deadline_response).toLocaleDateString('fr-FR')}</div>
                        </div>
                      )}
                      {viewingDemande.deadline_decision && (
                        <div className="bg-rose-50 rounded-lg p-2.5 border border-rose-200">
                          <div className="text-[10px] uppercase tracking-wider text-rose-700 font-semibold">Deadline decision</div>
                          <div className="text-sm font-semibold text-rose-900">{new Date(viewingDemande.deadline_decision).toLocaleDateString('fr-FR')}</div>
                        </div>
                      )}
                    </div>
                  )}
                </section>

                {/* Section : Notes internes */}
                {viewingDemande.notes && (
                  <section>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-slate-700 border-l-4 border-slate-400 pl-2 mb-2">
                      Notes internes (admin)
                    </h3>
                    <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap bg-amber-50/40 rounded-lg p-3 border border-amber-200">
                      {viewingDemande.notes}
                    </p>
                  </section>
                )}

                {/* Section : Acheteur / Tracabilite */}
                {(viewingDemande.buyer_email || viewingDemande.purchased_at || viewingDemande.updated_by) && (
                  <section>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-indigo-700 border-l-4 border-indigo-500 pl-2 mb-2">
                      Tracabilite
                    </h3>
                    <div className="bg-indigo-50/40 rounded-lg p-3 border border-indigo-200 text-xs space-y-1 text-slate-700">
                      {viewingDemande.buyer_email && (<div><span className="font-semibold">Acheteur :</span> {viewingDemande.buyer_email}</div>)}
                      {viewingDemande.purchased_at && (<div><span className="font-semibold">Achetee le :</span> {new Date(viewingDemande.purchased_at).toLocaleString('fr-FR')}</div>)}
                      {viewingDemande.updated_by && (<div><span className="font-semibold">Modifie par :</span> {viewingDemande.updated_by}</div>)}
                      {viewingDemande.updated_at && (<div><span className="font-semibold">Modifie le :</span> {new Date(viewingDemande.updated_at).toLocaleString('fr-FR')}</div>)}
                      {viewingDemande.duplicated_from && (<div><span className="font-semibold">Duplicata de :</span> <code className="text-[10px]">{viewingDemande.duplicated_from}</code></div>)}
                    </div>
                  </section>
                )}

                {/* Section : ID technique */}
                <section className="pt-2 border-t border-slate-200">
                  <div className="flex items-center justify-between text-[10px] text-slate-400 font-mono">
                    <span>ID complet : {viewingDemande.id || '—'}</span>
                    <button
                      type="button"
                      className="text-blue-500 hover:text-blue-700 underline-offset-2 hover:underline"
                      onClick={() => {
                        navigator.clipboard?.writeText(viewingDemande.id || '');
                        toast.success('ID copie');
                      }}
                      data-testid="copy-demande-id"
                    >
                      Copier l&apos;ID
                    </button>
                  </div>
                </section>
              </div>

              <DialogFooter className="px-6 py-3 bg-slate-50 border-t flex flex-row flex-wrap gap-2 justify-end">
                <Button
                  variant="outline"
                  onClick={() => setViewDialogOpen(false)}
                  data-testid="view-dialog-close"
                >
                  Fermer
                </Button>
                <Button
                  variant="outline"
                  onClick={() => { setViewDialogOpen(false); handleAdminDuplicateDemande(viewingDemande); }}
                  className="text-purple-600 border-purple-300 hover:bg-purple-50"
                  data-testid="view-dialog-duplicate"
                >
                  <Copy className="h-4 w-4 mr-1.5" /> Dupliquer
                </Button>
                <Button
                  onClick={() => { setViewDialogOpen(false); handleAdminEditDemande(viewingDemande); }}
                  className="bg-blue-600 hover:bg-blue-700"
                  data-testid="view-dialog-edit"
                >
                  <Edit2 className="h-4 w-4 mr-1.5" /> Modifier
                </Button>
              </DialogFooter>
            </>
          )}
        </DialogContent>
      </Dialog>
  );
};

export default ViewDemandeDialog;
